// Omnix/client/ui/HandoffController.js
import { ComponentBase } from "../core/ComponentBase.js";

export class HandoffController extends ComponentBase {
    constructor(config) {
        super(config);
        this.activeNotifications = new Map(); // conversationId -> HandoffNotification instance
        // --- FIX: Corrected typo (removed extra dot) ---
        this._boundHandleConversationUpdate = this.handleConversationUpdate.bind(this);
    }

    async initialize() {
        // --- FIX: Listen to the correct, namespaced server event ---
        this.appClient.events.server.on('unifiedInbox:conversationUpdated', this._boundHandleConversationUpdate);
        await super.initialize();
    }

    // ... (handleConversationUpdate, handleAccept, handleDecline methods are unchanged) ...
    async handleConversationUpdate(eventData) {
        const conversationId = eventData.conversationId;
        const updates = eventData.updates || {};

        if (updates.handoffState === 'ringing') {
            // A new handoff has started. Show the notification if we don't have one already.
            if (!this.activeNotifications.has(conversationId)) {
                try {
                    // Fetch full conversation details to show in the popup
                    const fullConversation = await this.appClient.rpcClient.call('UnifiedInboxRpc.getConversationById', { conversationId });
                    
                    const notification = await this.createManagedComponent('HandoffNotification', null, {
                        instanceId: `handoff-notif-${conversationId}`,
                        conversationData: fullConversation
                    });

                    notification.on('accepted', this.handleAccept.bind(this));
                    notification.on('declined', this.handleDecline.bind(this));
                    
                    this.activeNotifications.set(conversationId, notification);
                    notification.show();

                } catch (error) {
                    this.log.error(`Failed to create handoff notification for ${conversationId}:`, error);
                }
            }
        } else if (updates.handoffState === 'accepted' || updates.handoffState === 'rejected' || updates.status === 'closed') {
            // The handoff was resolved by someone (or closed). Hide the notification.
            if (this.activeNotifications.has(conversationId)) {
                const notification = this.activeNotifications.get(conversationId);
                notification.hide(); // This will trigger its own destroy method
                this.activeNotifications.delete(conversationId);
            }
        }
    }

    async handleAccept({ conversationId }) {
        try {
            await this.appClient.rpcClient.call('UnifiedInboxRpc.acceptHandoff', { conversationId });
            // The user who accepted should be navigated to the conversation.
            this.appClient.layoutEngine.navigate(`/user/inbox?conversationId=${conversationId}`);
        } catch (error) {
            this.log.error("Failed to accept handoff:", error);
            this.appClient.notifier.error(`Could not accept handoff: ${error.message}`);
        }
    }

    handleDecline({ conversationId }) {
        // Future implementation: could notify the server that this specific agent declined.
        this.log.info(`Handoff for ${conversationId} declined by this user.`);
        const notification = this.activeNotifications.get(conversationId);
        if (notification) {
            notification.hide();
            this.activeNotifications.delete(conversationId);
        }
    }

    render() {
        // This is a non-visual controller. It must return a valid, empty DOM element
        // to satisfy the LayoutEngine's appendChild requirement. A <div> is perfect.
        if (!this.container) {
            this.container = document.createElement('div');
            this.container.id = `handoff-controller-${this.config.instanceId}`;
            // It will be invisible and take up no space.
        }
        return this.container;
    }

    destroy() {
        // --- FIX: Unsubscribe from the correct event name ---
        this.appClient.events.server.off('unifiedInbox:conversationUpdated', this._boundHandleConversationUpdate);
        this.activeNotifications.forEach(notif => notif.destroy());
        this.activeNotifications.clear();
        super.destroy();
    }
}